function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();}function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o, minLen) {if (!o) return;if (typeof o === "string") return _arrayLikeToArray(o, minLen);var n = Object.prototype.toString.call(o).slice(8, -1);if (n === "Object" && o.constructor) n = o.constructor.name;if (n === "Map" || n === "Set") return Array.from(o);if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);}function _iterableToArray(iter) {if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);}function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr, len) {if (len == null || len > arr.length) len = arr.length;for (var i = 0, arr2 = new Array(len); i < len; i++) {arr2[i] = arr[i];}return arr2;}import LeechViewerRenderContext from './LeechViewerRenderContext';
import { DefaultLightPreset2d, DefaultLightPreset } from "../application/LightPresets";
import ResizeObserver from '../../thirdparty/resize-observer-polyfill/ResizeObserver.min.js';

// LeechViewer is a regular viewer, that lets you share resources (Models, Geometries & Materials) with other viewers.
// After rendering a frame, the result gets copied into the LeechViewer's canvas.
var protoCache = new Map();

// In order to support the ability to dynamically decide which ViewerClass to use, I had to wrap the initialization of the LeechViewer prototype in a function.
export function createLeechViewer(container, config, sharedResources, ViewerClass) {

  // In order to still share prototypes between different instances of leech viewers, we save the prototype in a cache.
  if (protoCache.has(ViewerClass)) {
    var proto = protoCache.get(ViewerClass);
    return new proto(container, config, sharedResources);
  }

  function LeechViewer(container) {var _this = this;var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};var sharedResources = arguments.length > 2 ? arguments[2] : undefined;
    this.sharedResources = sharedResources;
    this.loadingIntervals = {};

    ViewerClass.call(this, container, config);

    this.renderContext = new LeechViewerRenderContext(this.canvas);

    this.originalLoadDocumentNode = this.loadDocumentNode.bind(this);

    if (this.sharedResources.mrtFlags) {
      // Needed in order to sync the ID targets usage of the renderer.
      this.renderContext.mrtFlags = this.sharedResources.mrtFlags;
    } else {
      // save mrtFlags for the next leechViewer to use.
      this.sharedResources.mrtFlags = this.renderContext.mrtFlags;
    }

    this.resizeObserver = new ResizeObserver(function (entries) {
      var rect = entries[0].contentRect;
      var width = Math.floor(rect.width);
      var height = Math.floor(rect.height);

      // In case someone removed the viewer's container before properly destroyed the viewer.
      // In that case, we have to skip the rendering of that last frame - or we'll get tons of errors.
      if (!width || !height) {
        // Do not consider it as an error. It is not necessarily an error if the client app temporarily
        // hides the viewer canvas without deleting everything each time.
        return;
      }

      _this.impl.resize(width, height, true);

      _this.dispatchEvent({
        type: Autodesk.Viewing.VIEWER_RESIZE_EVENT,
        width: width,
        height: height });


      _this.impl.tick(performance.now());
    });

    this.resizeObserver.observe(this.container);
  }

  LeechViewer.prototype = Object.create(ViewerClass.prototype);
  LeechViewer.prototype.constructor = LeechViewer;

  LeechViewer.prototype.initialize = function () {var initOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var leechViewerInitOptions = {
      glrenderer: this.sharedResources.glrenderer,
      materialManager: this.sharedResources.materialManager,
      renderer: this.renderContext };


    var options = Object.assign({}, initOptions, leechViewerInitOptions);

    var nopViewerBackup = this.getWindow().NOP_VIEWER;

    var viewerErrorCode = ViewerClass.prototype.initialize.call(this, options);

    if (nopViewerBackup) {
      this.getWindow().NOP_VIEWER = nopViewerBackup;
    }

    this.overrideAPIs();

    if (this.sharedResources.geomCache && this.sharedResources.geomCache.initialized) {
      this.impl.setGeomCache(this.sharedResources.geomCache);
    }

    return viewerErrorCode;
  };

  LeechViewer.prototype.uninitialize = function () {var _this2 = this;
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    Object.keys(this.loadingIntervals).forEach(function (key) {
      _this2.clearLoadingInterval(key);
    });

    ViewerClass.prototype.uninitialize.call(this);
  };

  function generateKey(node, options) {
    var key = node.getModelKey();

    // Add options that can generate different geometry to unique key
    key += '.ref:' + !!options.applyRefPoint;

    if (options.globalOffset) {
      var arr = [options.globalOffset.x, options.globalOffset.y, options.globalOffset.z];
      key += '.g:' + arr.toString();
    }

    if (options.placementTransform) {
      key += '.p:' + options.placementTransform.toArray().toString();
    }

    if (options.customHash) {
      key += '.h:' + options.customHash;
    }

    return key;
  }

  // Override functions that need a special treatment in order to support shared renderer.
  LeechViewer.prototype.overrideAPIs = function () {var _this3 = this;
    // Before each tick, make sure the viewport is set to the right size.
    var originalTick = this.impl.tick.bind(this.impl);
    this.impl.tick = function () {
      _this3.impl.renderer().prepareViewport();
      // we pass the current time instead of the original argument from the tick function, because we want to take into consideration that other
      // viewers worked before this tick, on the same frame.
      var timestamp = performance.now();
      originalTick(timestamp);
      _this3.impl.renderer().restoreViewport();
    };

    // Only after renderPresented is done, copy the render target into the LeechViewer's canvas.
    // Priority is set to -1000, so in case of other event-listeners that should render to the target too, they'll do that prior to this.
    this.addEventListener(Autodesk.Viewing.RENDER_PRESENTED_EVENT, function () {
      _this3.renderContext.renderToCanvas();
    }, { priority: -1000 });

    var originalSetLightPreset = this.impl.setLightPreset.bind(this.impl);
    this.impl.setLightPreset = function (index, force, callback) {
      if (_this3.impl.is2d) {
        // In case of 2d, don't call `setLightPreset`, because it can unload 3D material resources that being used by other viewers.
        // Only set the background according to the light preset.
        _this3.impl.initLights();
        var bgColor2d = Autodesk.Viewing.Private.LightPresets[index].bgColorGradient;
        _this3.setBackgroundColor.apply(_this3, _toConsumableArray(bgColor2d));
        _this3.impl.setCurrentLightPreset(index);
        var cubeMap = _this3.impl.loadCubeMapFromColors(_this3.impl.clearColorTop, _this3.impl.clearColorBottom);
        _this3.impl.renderer().setCubeMap(cubeMap);
      } else {
        originalSetLightPreset(index, force, callback);
      }
    };

    this.impl.onBeforeRender = function (workThisTick) {
      if (workThisTick) {
        _this3.restoreViewerState();
      }
    };

    // Needed in order to restore cutplanes before selecting an object
    var originalInvokeStack = this.toolController.__invokeStack.bind(this.toolController);
    this.toolController.__invokeStack = function () {
      _this3.restoreViewerState();
      return originalInvokeStack.apply(void 0, arguments);
    };

    // Whenever unloadModel is called for a viewer, we want to make sure that it's resources are not being
    // used by other viewers. In that case, use keepResources flag to prevent disposing them.
    var originalUnloadModel = this.impl.unloadModel.bind(this.impl);
    this.impl.unloadModel = function (model) {
      var modelKey = model.leechViewerKey;

      var keepResources = false;

      // If model is not in loadedModels, it's a sign that it wasn't loaded, or it wasn't loaded using loadDocumentNode.    
      var modelItem = _this3.sharedResources.loadedModels[modelKey];

      if (modelItem) {
        modelItem.usedByViewersCounter--;
        keepResources = modelItem.forceKeepResources || modelItem.usedByViewersCounter > 0;

        if (!keepResources) {
          delete _this3.sharedResources.loadedModels[modelKey];
        }
      }

      _this3.clearLoadingInterval(modelKey);

      return originalUnloadModel(model, keepResources);
    };

    // When loading a model, make sure to check if it's already loaded by another viewer.
    this.loadDocumentNode = function (avDocument, manifestNode) {var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return new Promise(function (resolve, reject) {
        var key = generateKey(manifestNode, options);

        // Model already loaded
        var modelItem = _this3.sharedResources.loadedModels[key];

        if (modelItem) {
          var model = _this3.onModelLoaded(modelItem.model, options);
          resolve(model);
        } else {
          // If model is not loaded yet, load it, and cache it before resolving.
          _this3.originalLoadDocumentNode(avDocument, manifestNode, options).then(function (model) {
            model.leechViewerKey = key;
            _this3.sharedResources.loadedModels[key] = { model: model, usedByViewersCounter: 1, loadingViewer: _this3 };
            resolve(model);
          }).catch(reject);
        }
      });
    };

    var originalGeomCache = this.impl.geomCache.bind(this.impl);
    this.impl.geomCache = function () {
      if (!_this3.sharedResources.geomCache || !_this3.sharedResources.geomCache.initialized) {
        _this3.sharedResources.geomCache = originalGeomCache();
      }

      return _this3.sharedResources.geomCache;
    };
  };

  LeechViewer.prototype.setViewerProfile = function (model, options) {
    if (options.loadAsHidden) {
      return;
    }

    options.isAEC = model.isAEC();
    var profile = this.chooseProfile(options);

    // These settings change the model itself (not only the renderer settings).
    // We delete here so the current model's state won't change.
    delete profile.settings.lineRendering;
    delete profile.settings.pointRendering;

    this.setProfile(profile);
  };

  LeechViewer.prototype.setViewerLight = function (model, options) {
    if (options.loadAsHidden) {
      return;
    }

    // A fix for a case where one viewer has 3D model and on a different viewer a 2D model is loaded.
    // In that case, the materials gets updated with a 2D preset, that makes it appear black.
    if (this.impl.is2d) {

      this.impl.setLightPreset(DefaultLightPreset2d);

      var clearColorTopBackup = this.impl.clearColorTop.clone().multiplyScalar(255);
      var clearColorBottomBackup = this.impl.clearColorBottom.clone().multiplyScalar(255);

      if (options.isAEC) {
        this.impl.setLightPresetForAec();
      } else {
        this.impl.setLightPreset(DefaultLightPreset);
      }

      this.impl.toggleEnvMapBackground(false);

      this.setBackgroundColor(
      clearColorTopBackup.x, clearColorTopBackup.y, clearColorTopBackup.z,
      clearColorBottomBackup.x, clearColorBottomBackup.y, clearColorBottomBackup.z);

    } else {
      this.impl.toggleEnvMapBackground(this.profile.settings.envMapBackground);
    }
  };

  LeechViewer.prototype.cleanViewerBeforeLoadModel = function (options) {
    if (!options.keepCurrentModels && this.impl.hasModels()) {
      var _conf = this.config;
      this.tearDown();
      this.setUp(_conf);
    }

    // Add spinner for first model
    if (!this.impl.hasModels() && this._loadingSpinner) {
      this._loadingSpinner.show();
    }
  };

  var infiniteCutplane = new THREE.Vector4(0, 0, -1, -1e20);

  // We can't use matman.setCutPlanes() every frame, because it sets needsUpdate for all the materials, which is super heavy.
  // In order to skip that, we make sure that there is always at least one cutplane available, so materials include NUM_CUTPLANES > 0.
  LeechViewer.prototype.updateCutPlanes = function () {
    var cutplanes = this.impl.getAllCutPlanes() || [infiniteCutplane];
    var materialManager = this.impl.matman();

    var maxLength = Math.max(cutplanes.length, materialManager._cutplanes.length);

    // Empty array
    materialManager._cutplanes.length = 0;

    var i = 0;

    for (; i < cutplanes.length; i++) {
      materialManager._cutplanes.push(cutplanes[i].clone());
    }

    // Fill cutplanes array according to the largest cutplanes array.
    // This is needed because eventually, inside cutplanes.glsl you don't want to traverse over NUM_CUTPLANES with empty entries.
    for (; i < maxLength; i++) {
      materialManager._cutplanes.push(infiniteCutplane);
    }

    materialManager.forEach(function (mat) {
      mat.cutplanes = materialManager._cutplanes;
    }, false, true);
  };

  LeechViewer.prototype.restoreViewerState = function () {
    if (this.sharedResources.lastRenderedViewer !== this) {
      // Update cutplanes according to the current viewer.
      this.updateCutPlanes();

      // Needed for updated resolution for 2D shaders.
      if (this.impl.is2d) {
        this.impl.updateCameraMatrices();
      }

      // Finally, update last viewer that got rendered.
      this.sharedResources.lastRenderedViewer = this;
    }
  };

  LeechViewer.prototype.onModelLoaded = function (model, options) {
    var key = model.leechViewerKey;

    // forceKeepResources is being used here to make sure that while we cleanup the viewer,
    // and unload the same model that we just want to clone - we'll keep its resources.
    this.sharedResources.loadedModels[key].forceKeepResources = true;

    this.cleanViewerBeforeLoadModel(options);
    var modelClone = this.cloneModelToViewer(model);
    this.addModelToViewer(modelClone, options);

    delete this.sharedResources.loadedModels[key].forceKeepResources;

    return modelClone;
  };

  LeechViewer.prototype.addModelToViewer = function (model, options) {
    this.impl.modelQueue().addHiddenModel(model);

    if (!options.loadAsHidden) {
      this.setViewerProfile(model, options);
      this.showModel(model);
      this.setViewerLight(model, options);

      if (!options.headlessViewer && this.createUI) {
        this.createUI(model);
      }
    }

    if (this._loadingSpinner) {
      this._loadingSpinner.hide();
    }

  };

  LeechViewer.prototype.clearLoadingInterval = function (key) {
    if (this.loadingIntervals[key]) {
      clearInterval(this.loadingIntervals[key]);
      delete this.loadingIntervals[key];
    }
  };

  // Returns true if all pending loading is finished. More concrete, it means that there is no...
  //  - model-root loading
  //  - geometry loading, or
  //  - propDbLoading
  // pending or in progress.
  function isModelLoadDone(model) {
    var modelRootPending = !model;
    var geomPending = model && !model.isLoadDone();
    var propDbPending = model && model.getPropertyDb() && !model.getPropertyDb().isLoadDone();

    if (modelRootPending || geomPending || propDbPending) {
      return false;
    }

    return true;
  }

  // Returns a promise that resolves when isLoadDone() returns true.
  function waitForLoadDone(viewer, model) {
    return new Promise(function (resolve) {

      if (isModelLoadDone(model)) {
        resolve();
      }

      // On each load-relevant event, check if loading is finished.
      var onEvent = function onEvent() {
        if (!isModelLoadDone(model)) {
          return;
        }

        viewer.removeEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, onEvent);
        viewer.removeEventListener(Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT, onEvent);

        resolve();
      };

      // register event listeners to try again if something changes
      viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, onEvent);
      viewer.addEventListener(Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT, onEvent);
    });
  }

  LeechViewer.prototype.cloneModelToViewer = function (model) {var _this4 = this;
    // model.clone() returns a shallow copy of the model instance. All the internal state is shared between the models.
    // The reason we can't use the exact same instance, and we have to clone it, is because of VisibilityManager & Selector.
    // When a model is added to a viewer, the specific viewer instance is being used inside the selector, and
    // every model can have a single Selector & VisibilityManager.
    var modelClone = model.clone();

    var key = model.leechViewerKey;
    modelClone.leechViewerKey = key;

    var modelItem = this.sharedResources.loadedModels[key];
    modelItem.usedByViewersCounter++;
    var loadingViewer = modelItem.loadingViewer;

    // Until loading is done, keep refreshing the viewer, in order to mimic the invalidation inside the loaders.
    // A better way to do that would be to dispatch an event on the loading viewer's `processReceivedMesh`.
    this.clearLoadingInterval(key);

    this.loadingIntervals[key] = setInterval(function () {
      _this4.impl.invalidate(false, true, false);
    }, 1000);

    waitForLoadDone(loadingViewer, modelClone).then(function () {
      _this4.clearLoadingInterval(key);

      // onLoadComplete should be called after viewer.impl.addModel is called.
      // The reason is that viewer.impl.is2d is being set only there.
      // This timeout ensures it, and prevents a bug where 2D selection doesn't work (init2dSelection wasn't called because of that timing issue).
      // onLoadComplete is an async method anyway - so there is no risk in delaying it like that.
      setTimeout(function () {
        modelClone.setInnerAttributes(model.getInnerAttributes()); // Need to re-sync because of consolidationIterator is being set only when model loading is done.
        _this4.impl.onLoadComplete(modelClone);
      }, 1);
    });

    return modelClone;
  };

  protoCache.set(ViewerClass, LeechViewer);

  return new LeechViewer(container, config, sharedResources, ViewerClass);
}